"use client";


import type { TextareaProps } from "@components/ngg";
import { Textarea as NGGTextarea } from "@components/ngg";

import { cn } from "@/lib/utils";

export default function Textarea({
  classNames,
  endAdornment,
  label,
  id,
  required,
  placeholder = "",
  ...props
}: TextareaProps) {
  return (
    <NGGTextarea
      {...props}
      required={required}
      placeholder={placeholder}
      id={id}
      endAdornment={
        <>
          {label ? (
            <label
              htmlFor={id}
              className={cn(
                "pointer-events-none absolute bottom-2.5 left-4 top-2.5 text-base text-grey-300 transition-transform peer-focus:-translate-y-1.5 peer-focus:text-sm peer-[&:not(:placeholder-shown)]:-translate-y-1.5 peer-[&:not(:placeholder-shown)]:text-sm",
                classNames?.label,
              )}
            >
              {label}
              {required && "*"}
            </label>
          ) : null}
          {endAdornment}
        </>
      }
      classNames={{
        ...classNames,
        textarea: cn(
          "peer h-32 w-full border border-black px-4 py-3.5  text-base placeholder:text-transparent focus:placeholder:text-grey-300",
          classNames?.textarea,
        ),
      }}
    />
  );
}
